<style lang="less" scoped>
    .app-qr-code {
        position: relative;
        .qr-code {
            position: absolute;
            top: 0;
            right: 0px;
            width: 0;
            height: 0;
            opacity: 0;
            transition: all .3s ease-in-out;
            box-shadow:
                0px 6px 16px -8px rgba(0, 0, 0, 0.08),
                0px 9px 28px rgba(0, 0, 0, 0.05),
                0px 12px 48px 16px rgba(0, 0, 0, 0.03);

        }
        &:hover .qr-code {
            width: 180px;
            height: 180px;
            z-index: 10;
            opacity: 1;
            position: absolute;
            right: 0;
        }
    }
</style>
<template>
    <div class="app-qr-code">
        <slot>
            <div>
                手机作图
            </div>
        </slot>
        <img src="../../assets/qr-code.svg" class="qr-code" draggable="false">
    </div>
</template>

<script>
export default {

};
</script>
